//
//
//
//
//
//
//
//
//
//

import BcCheckStatus from '@/components/common/BcCheckStatus'
import ClientTrusted from '@/components/client/ClientTrusted'

export default {
  name: 'ClientName',
  components: {
    ClientTrusted,
    BcCheckStatus
  },
  props: {
    client: {
      type: Object,
      required: true
    }
  },
  computed: {
    displayTrusted () {
      return this.client?.trusted
    },
    name () {
      return this.client?.name
    }
  }
}
